module.exports = __webpack_public_path__ + "media/images/top-page_illustration-step1-09b3778724c129d9ef0752981a1a9e63.svg";